import { useEffect, useState } from 'react';
import {
  VERSION_POLL_INTERVAL_MS,
  checkForStaleAppVersion,
  isVersionCheckEnabled
} from '../utils/appVersion';

export function useStaleAppVersion({
  intervalMs = VERSION_POLL_INTERVAL_MS,
  checkVersion = checkForStaleAppVersion
} = {}) {
  const [isStale, setIsStale] = useState(false);

  useEffect(() => {
    if (!isVersionCheckEnabled()) {
      return undefined;
    }

    let cancelled = false;

    const check = async () => {
      if (typeof document !== 'undefined' && document.visibilityState === 'hidden') {
        return;
      }
      const result = await checkVersion();
      if (!cancelled && result.stale) {
        setIsStale(true);
      }
    };

    check();
    const intervalId = setInterval(check, intervalMs);
    const onVisibleOrFocus = () => {
      check();
    };

    document.addEventListener('visibilitychange', onVisibleOrFocus);
    window.addEventListener('focus', onVisibleOrFocus);

    return () => {
      cancelled = true;
      clearInterval(intervalId);
      document.removeEventListener('visibilitychange', onVisibleOrFocus);
      window.removeEventListener('focus', onVisibleOrFocus);
    };
  }, [checkVersion, intervalMs]);

  return isStale;
}
